import {
    RESET,
    RESET_CITIES,
    SELECT_MENU,
    HANDLE_CHANGE,
    SELECT_PLAN,
    LOGIN,
    INFO_USER,
    LOAD_CITIES,
    LOAD_MODEL,
    SUM_ASSURED,
    POST_DATA,
    POST_DATA_MENU,
    CONFIRM_CODE,
    LOADING,
    ALERT_DATA,
    SEARCH_COTIZACION,
    UPDATE_INFO_USERS,
    UPDATE_INFO_USER,
    UPDATE_INFO_SUCURSALES,
    UPDATE_INFO_REGIONS,
    UPDATE_INFO_ZONES,
    SET_CODEMP,
    GLOBAL_SHOW,
    DELETE_SINISTER,
    ERROR_BACK,
    SET_WAITING_CITIES
} from "../actions/types";
import { params } from "../actions/webServices";
import { initialStateMR } from './initialState';

export default function mainReducer(state = initialStateMR, { type, payload }) {
    switch (type) {
        case LOGIN: {
            if (payload.error) {
                return {
                    ...state,
                    user: { ...state.user, email: '', login: false, error: true, msgError: payload.msgError, id: '' },
                }
            } else {
                let nationality = payload.countries?.find(item => item.label === 'Argentina')?.value;
                if (payload.data.nacionalidad) {
                    let dataNationality = payload.countries?.find(item => item.label.toUpperCase() === payload.data.nacionalidad.toUpperCase())?.value;
                    if (dataNationality) {
                       nationality = dataNationality;
                    };
                }
                let stateRes = {
                    ...state,
                    user: {
                        habilitado: payload.user.habilitado,
                        email: payload.user?.email,
                        user: payload.user?.email,
                        password: payload.user?.password,
                        token: payload.token,
                        login: true,
                        id: payload.user.id,
                        vendor: payload.user.vendor,
                        sucursal: payload.user.sucursal,
                        isAdmin: payload.user.isAdmin,
                        opcusu: payload.user.opcusu,
                        test: payload.user.test,
                        level: payload.user.level,
                        legajo: payload.user.legajo,
                        name: payload.user.nombre,
                        address: payload.user.address,
                        sex: payload.user.sex,
                        disableInputs: !!payload.token,
                        nro: payload.user.nro,
                        grupo: payload.user.grupo,
                    },
                    menu: payload.menu,
                    nameCompany: payload.nameCompany,
                    activities: payload.activities,
                    provinces: payload.provinces,
                    vendors: payload.vendors,
                    sucursales: payload.sucursales,
                    regions: payload.regions,
                    zones: payload.zones,
                    optState: payload.optState,
                    company: payload.codemp,
                    sections: payload.sections,
                    availableSections: payload.availableSections,
                    sinistersSections: payload.sinistersSections,
                    sinistersStates: payload.sinistersStates,
                    companies: payload.companies,
                    products: payload.products,
                    consultaProductos: payload.consultaProductos,
                    countries: payload.countries,
                    arrPayMethod: payload.arrPayMethod,
                    payMethodMoto: payload.payMethodMoto,
                    coverages: payload.coverages,
                    causes: payload.causes,
                    relationship: payload.relationship,
                    optTypeUser: payload.optTypeUser,
                    ciaPol: payload.ciaPol,
                    empresas: payload.empresas,
                    opcEnabled: payload.opcEnabled,
                    mawdy: payload.mawdy,
                    moto: { ...state.moto, motoBrand: payload.brand },
                    firstStep: {
                        ...state.firstStep,
                        codcia: payload.menu[0]?.codcia,
                        province: payload.codProvincia ? payload.codProvincia : '',
                        codsec: payload.menu[0]?.codsec || 8,
                    },
                    titularData: { ...state.titularData, nationality },
                    cards: payload.cards,
                    infoCompany: payload.infoCompany,
                };
                if (payload.token) {
                    let city;
                    const province = payload.provinces.find(prov => prov.label.toUpperCase() === payload.data.provincia?.toUpperCase())?.value;
                    payload?.user?.email.startsWith("CA") ? city = payload.cities.find(city => city.label.toUpperCase() === payload.data.city.toUpperCase())?.label
                        : city = payload.cities.find(city => city.label.toUpperCase() === payload.data.city.toUpperCase())?.value;
                    const edit = province !== undefined && city !== undefined
                    if (!city) {
                        if (payload.data.localidad) {
                            city = payload.cities.find(city => city.nomloc === payload.data.localidad)?.value
                        } else city = ''
                    };
                    const codcia = payload.menu.find(it => it.codsec === 8) || payload.menu.find(it => it.codsec === 19);
                    stateRes = {
                        ...stateRes,
                        nomlcia: payload.city || '',
                        cities: payload.cities || [],
                        firstStep: {
                            ...state.firstStep,
                            dni: payload.data.dni || '',
                            email: payload.data.email || '',
                            birthday: payload.data.fecnac || '',
                            province: province ? province : '',
                            codcia: codcia?.codcia,
                            codsec: codcia?.codsec,
                            city: city ? city : '',
                            edit: payload?.user?.email.startsWith("CA") ? false : edit,
                        },
                        titularData: {
                            ...state.titularData,
                            genre: payload.data.sexo || '',
                            address: payload.data.domicilio || '',
                            domicilio: payload.data.domicilio && payload.data.domicilio.substring(0, payload.data.domicilio.length - payload.data.domicilio.split(" ").pop().length),
                            numAddress: payload.data.domicilio && payload.data.domicilio.split(" ").pop(),
                            name: payload.data.nombre || '',
                            lastname: payload.data.apellido || '',
                            area: payload.data.area || '',
                            phone: payload.data.telefono || '',
                            nationality,
                            postalcode: payload.data.codpos ? payload.data.codpos : '',
                        },
                        homeData: {
                            ...state.homeData,
                            address: payload.data.domicilio || '',
                        },
                    }
                };
                return stateRes;
            }
        }
        case HANDLE_CHANGE: {
            if (state[payload.step] && state[payload.step][payload.target.name] !== undefined) {
                return {
                    ...state,
                    [payload.step]: { ...state[payload.step], [payload.target.name]: payload.target.value },
                }
            }
            return state;
        }
        case SET_CODEMP: {
            return {
                ...state,
                company: payload,
            }
        }
        case SELECT_MENU: {
            return {
                ...state,
                firstStep: {
                    ...state.firstStep,
                    type: payload.value,
                    codsec: payload.id,
                    codcia: payload.codcia,
                    codpro: payload.codpro,
                    haveDiscount: payload.haveDiscount,
                    msgpde: payload.msgpde || "",
                },
                payMethod: {
                    id: null,
                    creditCard: '',
                    cardNumber: '',
                    fullName: '',
                    dni: '',
                    expires: '',
                },
            }
        }
        case SELECT_PLAN: {
            return {
                ...state,
                firstStep: { ...state.firstStep, plan: payload.plan, codpro: payload.codpro, price: payload.price, sumAssured: payload.sumAssured },
            }
        }
        case LOAD_CITIES: {
            let foundCity = null;
            if (payload?.nomlcia) {
                foundCity = payload.cities.find(p => p.label.toLowerCase().startsWith(payload.nomlcia.toLowerCase()));
            }
            return {
                ...state,
                cities: [...state.cities, ...payload?.cities],
                firstStep: {
                    ...state.firstStep,
                    city: foundCity ? foundCity?.value : '',
                    edit: !!foundCity,
                },
                homeData: {
                    ...state.homeData,
                    city: foundCity ? foundCity?.value : '',
                },
            }
        }
        case LOAD_MODEL: {
            return {
                ...state,
                loading: payload.loading,
                moto: {
                    ...state.moto,
                    motoModel: payload.models,
                    motoSumAssured: payload.assured,
                },
            }
        }
        case SUM_ASSURED: {
            return {
                ...state,
                firstStep: { ...state.firstStep, sumAssured: payload },
            }
        }
        case LOADING: {
            return {
                ...state,
                loading: payload,
            }
        }
        case GLOBAL_SHOW: {
            return {
                ...state,
                show: payload,
            }
        }
        case POST_DATA: {
            return {
                ...state,
                codpmpol: payload,
                loading: false,
            }
        }
        case DELETE_SINISTER: {
            return {
                ...state,
                sinisterDelete: payload
            }
        }
        case ALERT_DATA: {
            const { status, error, properties, totalNumberProperties, client } = payload;
            return {
                ...state,
                loading: false,
                codpmpol: payload.codpmpol,
                saveError: {
                    ...state.saveError,
                    errorDescription: status,
                    alertData: error,
                    client,
                    totalNumberProperties,
                    properties,
                }
            };
        }
        case ERROR_BACK: {
            return {
                ...state,
                saveError: {
                    ...state.saveError,
                    alertData: payload,
                    errorDescription: payload
                }
            }
        }
        case POST_DATA_MENU: {
            return {
                ...state,
                codpmpol: payload.codpmpol,
                loading: false,
                saveError: {
                    errorDescription: payload.error?.descripcion,
                    section: payload.error?.codsec,
                    details: payload.error?.detalle || [],
                },
                homeData: {
                    ...state.homeData,
                    registeredAddress: payload.error?.detalle,
                },
            }
        }
        case CONFIRM_CODE: {
            return {
                ...state,
                codpmpol: payload,
            }
        }
        case SEARCH_COTIZACION: {
            if (!payload?.cotizacion || !Array.isArray(payload.cotizacion)) {
                return state;
            }
            const cotizacion = [...payload.cotizacion].reverse().map((e) => {
                return { ...e, description: e.descripcion.split("!") }
            })
            return {
                ...state,
                codpmpol: payload.codpmpol,
                motoQuotes: cotizacion,
                loading: payload.loading,
                saveError: {
                    errorDescription: payload.error?.descripcion,
                    section: payload.error?.codsec,
                    details: payload.error?.detalle,
                },
                vehicleData: {
                    ...state.vehicleData,
                    registeredPatent: payload.error?.detalle,
                },
            }
        }
        case UPDATE_INFO_USER: {
            return {
                ...state,
                loading: false,
            }
        }
        case UPDATE_INFO_USERS: {
            let vendors = [];
            if (payload.borrado) {
                state.vendors.forEach(user => {
                    if (user['nom-usu'] !== payload.editado['nom-usu'])
                        vendors.push(user);
                })
            } else if (payload.nuevo) {
                let suc = state.sucursales?.find(suc => suc.value === payload.editado['cod-suc']);
                let reg = state.regions?.find(reg => reg.value === suc?.codreg);
                vendors = [
                    {
                        ...payload.editado,
                        label: payload.editado['ape-usu'],
                        value: payload.editado['ven-usu'],
                        region: reg?.value,
                        zona: reg?.codzon,
                    },
                    ...state.vendors
                ];
            } else {
                state.vendors.forEach(user => {
                    if (user['nom-usu'] !== payload.editado['nom-usu'])
                        vendors.push(user);
                    else
                        vendors.push({
                            ...user,
                            'ape-usu': payload.editado['ape-usu'],
                            'cod-suc': payload.editado['cod-suc'],
                            'dom-usu': payload.editado['dom-usu'],
                            'opc-usu': payload.editado['opc-usu'],
                            'cod-pca': payload.editado['cod-pca'],
                        });
                })
            }
            return {
                ...state,
                vendors,
                loading: false,
            }
        }
        case UPDATE_INFO_SUCURSALES: {
            let sucursales = [];
            if (payload.borrado) {
                state.sucursales.forEach(suc => {
                    if (suc.value !== payload.editado['cod-suc'])
                        sucursales.push(suc);
                })
            } else if (payload.nuevo) {
                sucursales = [{
                    value: payload.editado['cod-suc'],
                    label: payload.editado['nom-suc'],
                    codreg: payload.editado['cod-reg'],
                }, ...state.sucursales];
            } else {
                state.sucursales.forEach(suc => {
                    if (suc.value !== payload.editado['cod-suc']) {
                        sucursales.push(suc);
                    } else {
                        sucursales.push({
                            value: payload.editado['cod-suc'],
                            label: payload.editado['nom-suc'],
                            codreg: payload.editado['cod-reg'],
                        });
                    }
                });
            }
            return {
                ...state,
                sucursales,
                loading: false,
            }
        }
        case UPDATE_INFO_REGIONS: {
            let regions = [];
            if (payload.borrado) {
                state.regions.forEach(reg => {
                    if (reg.value !== payload.editado['cod-reg'])
                        regions.push(reg);
                })
            } else if (payload.nuevo) {
                regions = [{
                    value: payload.editado['cod-reg'],
                    label: payload.editado['nom-reg'],
                    codreg: payload.editado['cod-zon'],
                }, ...state.regions];
            } else {
                state.regions.forEach(reg => {
                    if (reg.value !== payload.editado['cod-reg']) {
                        regions.push(reg);
                    } else {
                        regions.push({
                            value: payload.editado['cod-reg'],
                            label: payload.editado['nom-reg'],
                            codzon: payload.editado['cod-zon'],
                        });
                    }
                });
            }
            return {
                ...state,
                regions,
                loading: false,
            }
        }
        case UPDATE_INFO_ZONES: {
            let zones = [];
            if (payload.borrado) {
                state.zones.forEach(zon => {
                    if (zon.value !== payload.editado['cod-zon'])
                        zones.push(zon);
                })
            } else if (payload.nuevo) {
                zones = [{
                    value: payload.editado['cod-zon'],
                    label: payload.editado['nom-zon'],
                }, ...state.zones];
            } else {
                state.zones.forEach(zon => {
                    if (zon.value !== payload.editado['cod-zon']) {
                        zones.push(zon);
                    } else {
                        zones.push({
                            value: payload.editado['cod-zon'],
                            label: payload.editado['nom-zon'],
                        });
                    }
                });
            }
            return {
                ...state,
                zones,
                loading: false,
            }
        }
        case RESET: {
            if (payload.resetCodpmpol)
                return {
                    ...state,
                    codpmpol: '',
                    firstStep: {
                        ...state.firstStep,
                        codcia: 0,
                    },
                    payMethod: {
                        id: null,
                        creditCard: '',
                        cardNumber: '',
                        fullName: '',
                        dni: '',
                        expires: '',
                    },
                }
            const codArgentina = state.countries?.find(item => item.label === 'Argentina')?.value
            const codcia = state.menu.find(m => m.codsec === 8) || state.menu.find(m => m.codsec === 19)

            params.set('codpmpol', '');
            params.set('ninpol', '');
            params.set('codemp', '');
            params.set('codsec', '');
            params.set('dnipol', '');
            params.set('emapol', '');
            params.set('nacpol', '');
            params.set('codloc', '');
            params.set('venusu', '');
            params.set('codusu', '');
            params.set('codpag', '');
            params.set('modpol', '');
            params.set('anopol', '');
            params.set('marpol', '');
            params.set('sexpol', '');
            params.set('codcia', '');
            params.set('facpol', '');
            params.set('nompol', '');
            params.set('apepol', '');
            params.set('dompol', '');
            params.set('telpol', '');
            params.set('codpai', '');
            params.set('cuipol', '');
            params.set('numpol', '');
            params.set('ecapol', '');
            params.set('arepol', '');
            params.set('codact', '');
            params.set('exppol', '');
            params.set('codpro', '');
            params.set('codloc', '');
            params.set('sumpol', '');
            params.set('idomloc', '');
            params.set('codviv', '');
            params.set('icodloc', '');
            params.set('mtspol', '');
            params.set('ckmpol', '');
            params.set('patpol', '');
            params.set('motpol', '');
            params.set('chapol', '');
            params.set('usopol', '');
            params.set('naspol', '');
            params.set('aaspol', '');
            params.set('faspol', '');
            params.set('daspol', '');
            params.set('modpol', '');
            params.set('marpol', '');
            params.set('codpag', '');
            params.set('codtar', '');
            params.set('tnumpol', '');
            params.set('ul4pol', '');
            params.set('tnompol', '');
            params.set('tdnipol', '');
            params.set('tvtopol', '');
            params.set('tarjetaPlana', '');
            params.set('prepol', '');
            params.set('blepol', '');
            params.set('pmben', '');
            params.set('lastBen', '');
            return {
                ...state,
                codpmpol: '',
                sinisterDelete: '',
                cities: [],
                show: false,
                motoQuotes: [],
                saveError: {
                    errorDescription: '',
                    section: '',
                    recid: '',
                    details: [],
                },
                firstStep: {
                    type: codcia?.codcia === 8 ? 'familiar' : codcia?.codcia === 19 ? 'protected' : '',
                    codsec: 8,
                    codpro: '',
                    codcia: codcia?.codcia || 0,
                    dni: '',
                    cuil: '',
                    email: '',
                    birthday: '',
                    province: '',
                    city: '',
                    brand: '',
                    year: new Date().getFullYear(),
                    genre: '',
                    model: '',
                    sumAssured: '',
                    price: '',
                    payMethod: '',
                    plan: '',
                    facpol: '',
                },
                titularData: {
                    name: '',
                    lastname: '',
                    between: '',
                    address: '',
                    numAddress: '',
                    postalcode: '',
                    city: '',
                    province: '',
                    genre: '',
                    area: '',
                    phone: '',
                    activity: 0,
                    expose: false,
                    nationality: codArgentina,
                },
                homeData: {
                    address: '',
                    homeType: '',
                    province: '',
                    city: '',
                    squareMeters: '',
                },
                tecnologyData: {
                    name: '',
                    lastname: '',
                    modelo: '',
                    product: '',
                    dni: '',
                    birthdate: '',
                    marca: '',
                },
                payMethod: {
                    id: null,
                    creditCard: '',
                    cardNumber: '',
                    fullName: '',
                    dni: '',
                    expires: '',
                },
                vehicleData: {
                    brand: '',
                    isNew: 'yes',
                    year: '',
                    patent: '',
                    model: '',
                    motor: '',
                    chassis: '',
                    use: 'particular',
                },
            }
        }
        case RESET_CITIES: {
            return {
                ...state,
                cities: [],
                firstStep: {
                    ...state.firstStep,
                    city: ''
                }
            }
        }
        case SET_WAITING_CITIES: {
            return {
                ...state,
                waitingCities: payload,
                saveError: {
                    ...state.saveError,
                    errorDescription: payload ? 'WaitingCities' : state.saveError.errorDescription,
                }
            }
        }
        case INFO_USER: {
            return {
                ...state,
                loading: false,
                user: {
                    ...state.user,
                    name: payload.nombre,
                    todaySales: payload.ventasHoy,
                    yesterdaySales: payload.ventasAyer,
                }
            }
        }
        default: {
            return state;
        }
    }
}
